// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitterSolo .viewMarkdown {
  justify-content: center;
  display: flex;
  animation: fadein 200ms;
}

.viewMarkdown {
  overflow: hidden;
  min-height: 100%;
}

.splitterSplit .viewMarkdown {
  height: 100%;
  min-height: 0;
  overflow: auto;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px #0000000d;
}

.splitterSplit .viewMarkdownContainer {
  max-width: 780px;
  margin: 0 auto;
  padding: 44px 48px;
}

.splitterSolo .viewMarkdownContainer {
  border: 1px solid var(--line);
  box-shadow:
    0 1px 3px #0000000f,
    0 10px 30px #00000008;
  margin: var(--markdown-padding);
  width: calc(100vw - 4 * var(--markdown-padding));
  flex: 1;
}

.viewMarkdownStickyHeader {
  margin-left: 15px;
  text-align: right;
  position: sticky;
  top: var(--header-padding);
  height: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 1;
}

.viewMarkdownContainer {
  --markdown-padding: 32px;
  padding: var(--markdown-padding);
  max-width: 1000px;
  line-height: 1.5;
  border-radius: 8px;
  font-size: 16px;
}

.viewMarkdownTable {
  width: 100%;
  overflow-x: scroll;
}

.viewMarkdownDiv p {
  margin-top: 0;
  margin-bottom: 16px;
}

.viewMarkdownDiv h1,
.viewMarkdownDiv h2 {
  margin-top: 0;
  border-bottom: 1px solid var(--line);
}

.viewMarkdownDiv h1 {
  padding-bottom: .3em;
  font-size: 2em;
}

.viewMarkdownDiv h1,
.viewMarkdownDiv h2,
.viewMarkdownDiv h3,
.viewMarkdownDiv h4,
.viewMarkdownDiv h5,
.viewMarkdownDiv h6 {
  font-family: var(--font-display);
}

/* The document title is the one display-face moment in FloppyDisk. */
.viewMarkdownDiv > h1:first-child {
  font-weight: 600;
  font-size: 2.5em;
  line-height: 1.15;
  letter-spacing: -0.005em;
  padding-bottom: 0.25em;
}

.viewMarkdownDiv h2 {
  padding-bottom: .3em;
  font-size: 1.5em;
}

.viewMarkdownDiv h3 {
  font-size: 1.25em;
  padding-bottom: 0.5;
}

.viewMarkdownDiv h3,
.viewMarkdownDiv h4,
.viewMarkdownDiv h5,
.viewMarkdownDiv h6 {
  margin-bottom: 0.5em;
}

.viewMarkdownDiv img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.viewMarkdownDiv table {
  display: block;
  width: max-content;
  max-width: 100%;
  overflow: auto;
  border-spacing: 0;
  border-collapse: collapse;
  margin-bottom: 1em;
}

.viewMarkdownDiv > *:first-child {
  margin-top: 0;
}

.viewMarkdownDiv table th,
.viewMarkdownDiv table td {
  padding: 6px 13px;
  border: 1px solid var(--line);
}

.viewMarkdownDiv pre {
  padding: 16px;
  background-color: #eee;
  overflow-x: auto;
  border-radius: 8px;
}

/* Override the global <code> rules. */
.viewMarkdownDiv pre > code {
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: 0;
}

.viewMarkdownDiv blockquote {
  padding: 0 1em;
  margin: 0;
  color: #555;
  border-left: 2px solid #555;
}

.splitterSplit .viewMarkdownDiv {
  /* When editing the markdown, give more padding at the bottom. */
  padding-bottom: calc(100vh - var(--header-padding) - 100px);
}

@media (max-width: 500px) {
  .viewMarkdownContainer,
  .splitterSolo .viewMarkdownContainer {
    margin: 0;
    width: calc(100vw - 1 * var(--markdown-padding));
  }
}

/* The close button. */
.ͼ1 .cm-panel.cm-search [name="close"] {
  font-size: 21px;
  cursor: pointer;
  padding: 4px;
}

@media print {
  .splitterSolo .viewMarkdownContainer {
    margin: 0;
    border: 0;
    width: 100%;
    max-width: none;
    padding: 0;
  }
  .viewMarkdownStickyHeader {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/ViewMarkdown.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;;yBAEuB;EACvB,+BAA+B;EAC/B,gDAAgD;EAChD,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;EAChE,2DAA2D;AAC7D;;AAEA;EACE;;IAEE,SAAS;IACT,gDAAgD;EAClD;AACF;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,SAAS;IACT,SAAS;IACT,WAAW;IACX,eAAe;IACf,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".splitterSolo .viewMarkdown {\n  justify-content: center;\n  display: flex;\n  animation: fadein 200ms;\n}\n\n.viewMarkdown {\n  overflow: hidden;\n  min-height: 100%;\n}\n\n.splitterSplit .viewMarkdown {\n  height: 100%;\n  min-height: 0;\n  overflow: auto;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 3px #0000000d;\n}\n\n.splitterSplit .viewMarkdownContainer {\n  max-width: 780px;\n  margin: 0 auto;\n  padding: 44px 48px;\n}\n\n.splitterSolo .viewMarkdownContainer {\n  border: 1px solid var(--line);\n  box-shadow:\n    0 1px 3px #0000000f,\n    0 10px 30px #00000008;\n  margin: var(--markdown-padding);\n  width: calc(100vw - 4 * var(--markdown-padding));\n  flex: 1;\n}\n\n.viewMarkdownStickyHeader {\n  margin-left: 15px;\n  text-align: right;\n  position: sticky;\n  top: var(--header-padding);\n  height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  z-index: 1;\n}\n\n.viewMarkdownContainer {\n  --markdown-padding: 32px;\n  padding: var(--markdown-padding);\n  max-width: 1000px;\n  line-height: 1.5;\n  border-radius: 8px;\n  font-size: 16px;\n}\n\n.viewMarkdownTable {\n  width: 100%;\n  overflow-x: scroll;\n}\n\n.viewMarkdownDiv p {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.viewMarkdownDiv h1,\n.viewMarkdownDiv h2 {\n  margin-top: 0;\n  border-bottom: 1px solid var(--line);\n}\n\n.viewMarkdownDiv h1 {\n  padding-bottom: .3em;\n  font-size: 2em;\n}\n\n.viewMarkdownDiv h1,\n.viewMarkdownDiv h2,\n.viewMarkdownDiv h3,\n.viewMarkdownDiv h4,\n.viewMarkdownDiv h5,\n.viewMarkdownDiv h6 {\n  font-family: var(--font-display);\n}\n\n/* The document title is the one display-face moment in FloppyDisk. */\n.viewMarkdownDiv > h1:first-child {\n  font-weight: 600;\n  font-size: 2.5em;\n  line-height: 1.15;\n  letter-spacing: -0.005em;\n  padding-bottom: 0.25em;\n}\n\n.viewMarkdownDiv h2 {\n  padding-bottom: .3em;\n  font-size: 1.5em;\n}\n\n.viewMarkdownDiv h3 {\n  font-size: 1.25em;\n  padding-bottom: 0.5;\n}\n\n.viewMarkdownDiv h3,\n.viewMarkdownDiv h4,\n.viewMarkdownDiv h5,\n.viewMarkdownDiv h6 {\n  margin-bottom: 0.5em;\n}\n\n.viewMarkdownDiv img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.viewMarkdownDiv table {\n  display: block;\n  width: max-content;\n  max-width: 100%;\n  overflow: auto;\n  border-spacing: 0;\n  border-collapse: collapse;\n  margin-bottom: 1em;\n}\n\n.viewMarkdownDiv > *:first-child {\n  margin-top: 0;\n}\n\n.viewMarkdownDiv table th,\n.viewMarkdownDiv table td {\n  padding: 6px 13px;\n  border: 1px solid var(--line);\n}\n\n.viewMarkdownDiv pre {\n  padding: 16px;\n  background-color: #eee;\n  overflow-x: auto;\n  border-radius: 8px;\n}\n\n/* Override the global <code> rules. */\n.viewMarkdownDiv pre > code {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n}\n\n.viewMarkdownDiv blockquote {\n  padding: 0 1em;\n  margin: 0;\n  color: #555;\n  border-left: 2px solid #555;\n}\n\n.splitterSplit .viewMarkdownDiv {\n  /* When editing the markdown, give more padding at the bottom. */\n  padding-bottom: calc(100vh - var(--header-padding) - 100px);\n}\n\n@media (max-width: 500px) {\n  .viewMarkdownContainer,\n  .splitterSolo .viewMarkdownContainer {\n    margin: 0;\n    width: calc(100vw - 1 * var(--markdown-padding));\n  }\n}\n\n/* The close button. */\n.ͼ1 .cm-panel.cm-search [name=\"close\"] {\n  font-size: 21px;\n  cursor: pointer;\n  padding: 4px;\n}\n\n@media print {\n  .splitterSolo .viewMarkdownContainer {\n    margin: 0;\n    border: 0;\n    width: 100%;\n    max-width: none;\n    padding: 0;\n  }\n  .viewMarkdownStickyHeader {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
